var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return Number(_vm.innerAttrs.total) > 0 ? _c('div', { staticClass: "pagination" }, [_c('el-pagination', _vm._g(_vm._b({ attrs: { "page-size": _vm.innerAttrs.pageSize, "current-page": _vm.innerCurrentPage }, on: { "update:pageSize": function updatePageSize($event) {
        return _vm.$set(_vm.innerAttrs, "pageSize", $event);
      }, "update:page-size": function updatePageSize($event) {
        return _vm.$set(_vm.innerAttrs, "pageSize", $event);
      }, "update:currentPage": function updateCurrentPage($event) {
        _vm.innerCurrentPage = $event;
      }, "update:current-page": function updateCurrentPage($event) {
        _vm.innerCurrentPage = $event;
      } } }, 'el-pagination', _vm.innerAttrs, false), _vm.$listeners))], 1) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };